import { UPDATE_AGENT_PASSWORD } from '../../endpoints';
import { IAgent } from '../../types/agent';
import makeAuthenticatedRequest from '../base-api';

interface UpdateAgentPasswordResponse {
  success: boolean;
  message?: string;
  updatedAgent?: IAgent;
}

const updateAgentPassword = async (payload: {
  agentId: string;
  brandId: string;
  newPassword: string;
}): Promise<UpdateAgentPasswordResponse> => {
  try {
    const response = await makeAuthenticatedRequest(UPDATE_AGENT_PASSWORD, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Update agent failed:', error);
    throw error;
  }
};

export { updateAgentPassword, type UpdateAgentPasswordResponse };
